module.exports = __webpack_public_path__ + "static/media/DSCF0013.7327e366.jpg";